import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/training-consultancy/page.tsx")